import axios from 'axios';

/**
 * Translates English text to Marathi using Google Translate API.
 * @param {string} text - The text to be translated.
 * @returns {Promise<string>} - The translated Marathi text or original text as fallback.
 */
export const translateToMarathi = async (text) => {
  if (!text || text.trim() === '') return '';

  try {
    const url = `https://translate.googleapis.com/translate_a/single?client=gtx&sl=en&tl=mr&dt=t&q=${encodeURIComponent(text)}`;
    const response = await axios.get(url);
    
    if (response.data && response.data[0] && response.data[0][0] && response.data[0][0][0]) {
      return response.data[0][0][0];
    }
    return text; // Fallback to original text if structure is unexpected
  } catch (error) {
    console.error('Translation error:', error);
    return text; // Fallback to original text on API error
  }
};
